<template>
  <div class="container treatment-open-getting">
    <div class="row pt-2">
      <div class="col-12 offset-md-2 col-md-8">
        <vm-progress :percentage="24" :show-text="false" :stroke-width="12" :strokeColor="'#2bb1c4'"></vm-progress>
      </div>
    </div>
    <back-and-skip :hideSkip='true'>
    </back-and-skip>
    <div class="row pt-4 pt-lg-2">
      <div class="col-12 text-center">
        <img class="img-question" src="../assets/treatment_open_getting.svg" alt="would-get-vaccinated">
      </div>
    </div>
    <div class="row pt-3 row-title">
      <div class="col-12 offset-lg-2 col-lg-8 text-center text-wrap">
        <label class="title">
          {{ $t('treatmentOpenToGetting.title') }}
        </label>
      </div>
    </div>
    <div class="row pt-4">
      <div class="col-6 offset-lg-3 col-lg-4 pr-0">
        <div class="condition-option">
          <input type="checkbox" id="moderna-vaccine" @change="check('moderna-vaccine')">
          <label for="moderna-vaccine">{{ $t('treatmentOpenToGetting.modernaVaccine') }}</label>
        </div>
      </div>
      <div class="col-6 col-lg-4 pl-0">
        <div class="condition-option">
          <input type="checkbox" id="pfizer-vaccine" @change="check('pfizer-vaccine')">
          <label for="pfizer-vaccine">{{ $t('treatmentOpenToGetting.pfizerVaccine') }}</label>
        </div>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-6 offset-lg-3 col-lg-4 pr-0">
        <div class="condition-option">
          <input type="checkbox" id="lilly-antibody" @change="check('lilly-antibody')">
          <label for="lilly-antibody">{{ $t('treatmentOpenToGetting.lillyAntibody') }}</label>
        </div>
      </div>
      <div class="col-6 col-lg-4 pl-0">
        <div class="condition-option">
          <input type="checkbox" id="roche-antibodies" @change="check('roche-antibodies')">
          <label for="roche-antibodies">{{ $t('treatmentOpenToGetting.rocheAntibody') }}</label>
        </div>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-6 offset-lg-3 col-lg-4 pr-0">
        <div class="condition-option">
          <input type="checkbox" id="gilead-drug" @change="check('gilead-drug')">
          <label for="gilead-drug">{{ $t('treatmentOpenToGetting.gileadDrug') }}</label>
        </div>
      </div>
      <div class="col-6 col-lg-4 pl-0">
        <div class="condition-option">
          <input type="checkbox" id="novavax-vaccine" @change="check('novavax-vaccine')">
          <label for="novavax-vaccine">{{ $t('treatmentOpenToGetting.novavaxVaccine') }}</label>
        </div>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-6 offset-lg-3 col-lg-4 pr-0">
        <div class="condition-option">
          <input type="checkbox" id="inovio-vaccine" @change="check('inovio-vaccine')">
          <label for="inovio-vaccine">{{ $t('treatmentOpenToGetting.inovioVaccine') }}</label>
        </div>
      </div>
      <div class="col-6 col-lg-4 pl-0">
        <div class="condition-option">
          <input type="checkbox" id="abbvie-drug" @change="check('abbvie-drug')">
          <label for="abbvie-drug">{{ $t('treatmentOpenToGetting.abbvieDrug') }}</label>
        </div>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-6 offset-lg-3 col-lg-4 pr-0">
        <div class="condition-option">
          <input type="checkbox" id="regeneron-antibody" @change="check('regeneron-antibody')">
          <label for="regeneron-antibody">{{ $t('treatmentOpenToGetting.regeneronAntibody') }}</label>
        </div>
      </div>
      <div class="col-6 col-lg-4 pl-0">
        <div class="condition-option">
          <input type="checkbox" id="gsk-vaccine" @change="check('gsk-vaccine')">
          <label for="gsk-vaccine">{{ $t('treatmentOpenToGetting.gskVaccine') }}</label>
        </div>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-6 offset-lg-3 col-lg-4 pr-0">
        <div class="condition-option">
          <input type="checkbox" id="other" @change="check('other')">
          <label for="other">{{ $t('treatmentOpenToGetting.other') }}</label>
        </div>
      </div>
    </div>
    <div class="row pt-3">
      <div class="col-12 offset-lg-2 col-lg-8 text-center">
        <input v-model="other"
          placeholder="Other"
          type="text"
          class="form-control other"
          :style="{visibility: showOther? 'visible' : 'hidden'}">
      </div>
    </div>
    <div class="row pt-3 pb-2">
      <div class="col-12 offset-lg-2 col-lg-8 text-center">
        <button class="btn btn-lg text-light next" @click="next">
          {{ $t('general.next') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'
import BackAndSkip from '../components/BackAndSkip.vue'

export default {
  data () {
    return {
      treatments: [],
      other: '',
      showOther: false
    }
  },
  components: {
    BackAndSkip
  },
  methods: {
    check (value) {
      if (this.treatments.includes(value)) {
        const index = this.treatments.indexOf(value)
        if (value === 'other') {
          this.showOther = false
          this.other = ''
        }
        this.treatments.splice(index, 1)
      } else {
        if (value === 'other') {
          this.showOther = true
        }
        this.treatments.push(value)
      }
    },
    next () {
      if (this.$v.$invalid) {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: this.$t('general.oneItemError')
        })
      } else {
        if (this.treatments.includes('other')) {
          if (this.other === '') {
            this.$swal({
              icon: 'error',
              title: 'Error',
              text: this.$t('general.pleaseSpecifyError')
            })

            return
          }
          let index = this.treatments.indexOf('other')

          this.treatments[index] = this.other
        }

        const answer = {
          key: 'which_treatment_open_to_getting',
          value: this.treatments
        }

        this.$store.commit('SET_DATA_SURVEY', answer)

        this.$router.push({
          name: 'concernedaboutvaccination'
        })
      }
    }
  },
  validations: {
    treatments: {
      required,
      minLength: minLength(1)
    }
  },
  mounted () {
    this.$store.commit('SET_LAST_PAGE', 'treatmentopengetting')
  }
}
</script>

<style>
.treatment-open-getting .img-question {
  width: 100%;
  height: 23vh;
}

.treatment-open-getting .title {
  font-weight: 700;
  font-size: 1.3rem;
}

.treatment-open-getting .condition-option input {
  padding: 0;
  height: initial;
  width: initial;
  margin-bottom: 0;
  display: none;
  cursor: pointer;
}

.treatment-open-getting .condition-option label {
  position: relative;
  cursor: pointer;
  font-size: .8rem;
}

.treatment-open-getting .condition-option label:before {
  content:'';
  -webkit-appearance: none;
  background-color: transparent;
  border: 1px solid #e3e3e3;
  padding: 10px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 10px;
}

.treatment-open-getting .condition-option input:checked + label:after {
  content: '';
  display: block;
  position: absolute;
  top: 2px;
  left: 9px;
  width: 7px;
  height: 15px;
  border: solid #34ace0;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.treatment-open-getting .next {
  width: 85%;
  min-height: 83px;
  background-color: #2bb1c4;
  font-weight: 300;
  border-radius: 15px;
}

.treatment-open-getting .other {
  width: 100%;
  height: 5vh;
  font-size: 12px;
  color: black;
}

@media screen and (device-aspect-ratio: 40/71) {
  .treatment-open-getting .img-question {
    width: 100%;
    height: 16vh;
  }

  .treatment-open-getting .title {
    font-size: 1rem;
  }

  .treatment-open-getting .condition-option label {
    font-size: .65rem;
  }

  .treatment-open-getting .other {
    width: 100%;
    height: 6vh;
  }

  .treatment-open-getting .next {
    min-height: 70px;
  }
}
</style>
